import { UiService } from '@services/ui.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import * as moment from 'moment';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  private baseUrl: string = environment.apiUrl + 'reports';

  constructor(
    private http: HttpClient,
    private uiSrv: UiService,
  ) {}

  exportReports(
    request: PaginationRequest,
    isMission?: boolean,
    includePrices?: boolean,
  ) {
    let httpParams = new HttpParams();

    if (includePrices) {
      httpParams = httpParams.append('includePrices', 'true');
    }

    if (request.query) {
      const filters = request.query;
      const filtersQuery = [];

      if (filters.identifier) {
        filtersQuery.push(`identifier==${filters.identifier}`);
      }
      if (filters.type) {
        if (filters.type !== 'all') {
          filtersQuery.push(`type==${filters.type}`);
        }
      }
      if (filters.status) {
        if (filters.status !== 'all') {
          filtersQuery.push(`status==${filters.status}`);
        }
      }
      if (filters.driver) {
        filtersQuery.push(`driver@=${filters.driver}`);
      }
      if (filters.client) {
        filtersQuery.push(`client@=${filters.client}`);
      }
      if (filters.site) {
        filtersQuery.push(`site@=${filters.site}`);
      }
      // if (filters.startDate) {
      //   filtersQuery.push(`startDate>=${moment(new Date(filters.fromStartDate)).startOf('day').utc().format("YYYY-MM-DD HH:mm")}`);
      //   filtersQuery.push(`startDate>=${moment(new Date(filters.fromStartDate)).endOf('day').utc().format("YYYY-MM-DD HH:mm")}`);
      // }
      if (filters.range?.fromStartDate) {
        filtersQuery.push(
          `startDate>=${moment(new Date(filters.range.fromStartDate)).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')}`,
        );
      }
      if (filters.range?.toStartDate) {
        filtersQuery.push(
          `startDate<=${moment(new Date(filters.range.toStartDate)).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')}`,
        );
      }
      if (filters.createdBy) {
        filtersQuery.push(`createdBy@=${filters.createdBy}`);
      }
      if (filters.urgency) {
        filtersQuery.push(`urgency@=${filters.urgency}`);
      }
      if (filters.sender) {
        filtersQuery.push(`sender@=${filters.sender}`);
      }
      if (filters.receiver) {
        filtersQuery.push(`receiver@=${filters.receiver}`);
      }

      httpParams = httpParams.append('Filters', filtersQuery.join());
    }

    if (isMission) {
      httpParams = httpParams.append('isAssigned', 'true');
    } else {
      httpParams = httpParams.append('isAssigned', 'false');
    }

    this.uiSrv.loadingStateChanged.next(true);
    return this.http
      .get(`${this.baseUrl}`, {
        params: httpParams,
        observe: 'response',
        responseType: 'blob',
      })
      .pipe(map((res) => this.saveFile(res)));
  }

  private saveFile(res: HttpResponse<Blob>): Blob {
    FileSaver.saveAs(res.body, res.headers.get('filename'));
    this.uiSrv.loadingStateChanged.next(false);
    return res.body;
  }
}
